// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GbBI","question":"styles_question__3GqdU","inputVisibleButton":"styles_inputVisibleButton__10oeT","note":"styles_note__zlDYC"};